// 261023 E3-P3h1 (K9 / V1) — chọn tab mặc định của trang truyện. THUẦN, không antd/react.
// `progress.chapters` = số chương ở tab Chapters (= số tập đã đẩy sang cho Film Plans, `AdaptationProgress`). 0 ⇒ chắc chắn chưa có Film Plan ⇒ mở «Chuyển thể»
// (nơi làm việc của truyện mới). Dữ liệu có sẵn từ `adaptationApi.progress` — KHÔNG thêm route.
export type FilmProgress = { chapters: number } | 'failed' | null;

export interface ActiveTab { tab: string; /** Film Mode, chưa chọn tab, progress đang tải: đừng vẽ tab nào (tránh nhấp nháy rồi đổi). */ pending: boolean }

export const resolveActiveTab = (i: { mode: 'film' | 'narration'; tabParam: string | null | undefined; progress: FilmProgress }): ActiveTab => {
  if (i.tabParam) return { tab: i.tabParam, pending: false };
  if (i.mode !== 'film') return { tab: 'overview', pending: false };
  if (i.progress === null) return { tab: 'film', pending: true };
  if (i.progress !== 'failed' && i.progress.chapters === 0) return { tab: 'adaptation', pending: false };
  return { tab: 'film', pending: false };
};

/** R4/F4 — `progress` chỉ dùng cho ĐÚNG truyện đã tải nó; đổi truyện cùng route (component không unmount) ⇒ null (đang tải) cho tới khi progress của truyện mới về. */
export const progressFor = (storyId: string | undefined, state: { id: string; v: FilmProgress } | null | undefined): FilmProgress => (state && storyId && state.id === storyId ? state.v : null);
